class SiteApp {
    constructor() {
        const _ = this;

        _.rgpd();
        _.load();
    }
    rgpd() {
        if (!getCookie("cookies-rgpd")) {
            $('#cookies-rgpd').show();
            $('#cookies-rgpd button').click(function () {
                $('#cookies-rgpd').remove();
                if ($(this).hasClass('accept'))
                    setCookie("cookies-rgpd", "accepted", 3600);
                else
                    setCookie("cookies-rgpd", "refused", 3600);
            });
        } else {
            $('#cookies-rgpd').remove();
        }
    }
    load() {
        const _ = this;

        if ($('body').hasClass('bg-resize')) {
            _.onResize();
            $(window).resize(function () {
                _.onResize();
            });
        }

        let pwd_field = document.querySelectorAll('input.pma_password'),
            pwd_revealer = [],
            pwd_revealer_label = [];
        for (let i = 0, limit = pwd_field.length; i < limit; ++i) {
            pwd_field[i].insertAdjacentHTML('afterend',
                '<input type="checkbox" id="pma_revealer-' + i + '" class="invisible" aria-hidden="true">' +
                '<label for="pma_revealer-' + i + '" class="glyphicon glyphicon-eye-open form-control-feedback" aria-hidden="true"></label>'
            );
            console.log(pwd_field[i])
            pwd_revealer[i] = pwd_field[i].parentElement.querySelector('input#pma_revealer-' + i);
            pwd_revealer_label[i] = pwd_field[i].parentElement.querySelector('label[for="pma_revealer-' + i + '"]');
            pwd_revealer[i].setAttribute('style', 'position: absolute; left: -99999rem;');
            pwd_revealer_label[i].style.pointerEvents = 'auto';
            pwd_revealer[i].addEventListener('change', function () {
                switch (pwd_revealer[i].checked) {
                    case true:
                        pwd_field[i].setAttribute('type', 'text');
                        pwd_revealer_label[i].classList.remove('glyphicon-eye-open');
                        pwd_revealer_label[i].classList.add('glyphicon-eye-close');
                        break;
                    case false:
                        pwd_field[i].setAttribute('type', 'password');
                        pwd_revealer_label[i].classList.remove('glyphicon-eye-close');
                        pwd_revealer_label[i].classList.add('glyphicon-eye-open');
                        break;
                }
            });
        }

        $(window).scroll(function () {
            if ($(window).scrollTop() >= 300)
                $('#back-to-top').stop().fadeIn(300);
            else
                $('#back-to-top').stop().fadeOut(300);
        });
        $('#back-to-top').click(function () {
            $('html, body').scrollTop(0);
        });

        $('#header .logo').hover(function () {
            $('html').toggleClass('logo-hover');
        });


        /* HOME */
        $('#mobile-menu').on('change', function () {
            $('html').toggleClass('menu-open');
        });

        // $('body.bg-image:not(.no-video)').each(function () {
        //     if (SiteApp.isMobile())
        //         return false;

        //     let preloader = '',
        //         video = '';
        //     if ($('body').hasClass('home')) {
        //         preloader = `/assets/site/js/preloader-video-home.json?_t=${Date.now()}`;
        //     } else if ($('body').hasClass('home-explorer')) {
        //         preloader = `/assets/site/js/preloader-video-home-rdg.json?_t=${Date.now()}`;
        //     } else {
        //         return;
        //     }


        //     const loadCirlce = (percentage = 0) => {
        //         const size = Math.min($('.circle-progress').parents('svg').width(), $('.circle-progress').parents('svg').height()),
        //             radius = (size - parseInt($('.circle-progress').css('stroke-width'))) / 2,
        //             dashArray = radius * Math.PI * 2;

        //         $('.circle-progress').css({
        //             strokeDasharray: dashArray,
        //             strokeDashoffset: dashArray - dashArray * percentage / 100
        //         });

        //         $('#background .loader .percentage').text(`${percentage}%`);
        //     };

        // $('#background .loader').addClass('loading');
        // new SiteLoader(preloader, {
        //     progress: percentage => {
        //         loadCirlce(percentage);
        //     },
        //     complete: () => {
        //         $('#background .loader').fadeOut(function () {
        //             video.addClass('loaded');
        //             $(this).remove();
        //         });
        //     },
        // elementLoaded: (obj, elm) => {
        //     if (obj.source && obj.sourceObject) {
        //         video = $(`<video class="video" data-video-width="1920" data-video-height="1920" class="loop" disablePictureInPicture autoplay loop muted preload="auto" src="${obj.sourceObject}"></video>`);
        //         $('#background .wrapper').append(video);
        //     }
        // }
        // });
        // });

        $('body.bg-image-zoom').each(function () {
            let preloader = '',
                image_magnifier = '';
            const imageZoomResize = () => {
                $('#bg-image-zoom').css('height', `calc(100vh - ${$('#header').height()}px)`);
                $('.magnifier #background > .wrapper').css('transform', `translateY(${-$('#header').height()}px)`);
            },
                loadCirlce = (percentage = 0) => {
                    const size = Math.min($('.circle-progress').parents('svg').width(), $('.circle-progress').parents('svg').height()),
                        radius = (size - parseInt($('.circle-progress').css('stroke-width'))) / 2,
                        dashArray = radius * Math.PI * 2;

                    $('.circle-progress').css({
                        strokeDasharray: dashArray,
                        strokeDashoffset: dashArray - dashArray * percentage / 100
                    });

                    $('#bg-image-zoom .loader .percentage').text(`${percentage}%`);
                },
                magnifier = (id_elem = '', url_large = '') => {
                    if (!id_elem || !url_large)
                        return false;

                    var evt = new Event(),
                        m = new Magnifier(evt);
                    m.attach({
                        thumb: id_elem,
                        large: url_large,
                        mode: 'inside',
                        zoom: 3,
                    });
                };

            imageZoomResize();
            $(window).resize(imageZoomResize);

            if ($('body').hasClass('home')) {
                preloader = `/assets/site/js/preloader-home.json?_t=${Date.now()}`;
                image_magnifier = '/assets/site/images/home-landscape-highrez.webp';
            } else if ($('body').hasClass('home-explorer')) {
                preloader = `/assets/site/js/preloader-home-rdg.json?_t=${Date.now()}`;
                image_magnifier = '/assets/site/images/home-rdg-landscape-highrez.webp';
            } else {
                return;
            }

            new SiteLoader(preloader, {
                progress: percentage => {
                    loadCirlce(percentage);
                },
                complete: () => {
                    imageZoomResize();
                    setTimeout(() => {
                        if (SiteApp.isTouchDevice() && SiteApp.isMobile()) {
                            $('#image-magnifier').on('load', function () {
                                $('#bg-image-zoom > .loader').fadeOut(function () {
                                    $(this).remove();
                                });
                            });
                            $('#image-magnifier').attr('src', image_magnifier);
                            new PinchZoom.default(document.getElementById('image-magnifier'), {
                                draggableUnzoomed: false
                            });
                        } else {
                            $('#bg-image-zoom > .loader').fadeOut(function () {
                                magnifier('#image-magnifier', image_magnifier);
                                $(this).remove();
                            });
                        }
                    }, 1500);
                }
            });
        });
        /* /HOME */



        /* DATA PAGES */
        $('[data-count]').each(function () {
            let animation,
                elem = $(this),
                end = elem.text(),
                animationFunction = () => {
                    animation?.restart();
                    $({ someValue: 0 }).animate({ someValue: end }, {
                        duration: 1000,
                        easing: 'swing',
                        step: function () {
                            elem.text(Math.ceil(this.someValue).toString().numberWithspace());
                        },
                        complete: function () {
                            elem.text(end.toString().numberWithspace());
                        }
                    });
                },
                data = {
                    scrollTrigger: {
                        trigger: this,
                        // markers: true,
                        onEnter: animationFunction,
                        onEnterBack: animationFunction
                    }
                };
            animation = gsap.to(this, data);
        });

        $('svg#fig1').each(function () {
            let svg = $(this),
                numbers = {
                    n1: $('[data-number1]', svg).text(),
                    n2: $('[data-number2]', svg).text(),
                },
                animationCounter = (elem, end) => {
                    $({ someValue: 0 }).animate({ someValue: end }, {
                        duration: 1000,
                        easing: 'swing',
                        step: function () {
                            elem.text(Math.ceil(this.someValue).toString().numberWithspace());
                        },
                        complete: function () {
                            elem.text(end.toString().numberWithspace());
                        }
                    });
                },
                tl = gsap.timeline()
                    .set($('.fig1-mask', svg), {
                        attr: {
                            x: 3,
                            width: 401
                        }
                    })
                    .set($('[data-number1], [data-number2]', svg), {
                        innerHTML: 0
                    })
                    .to(this, {
                        onStart: () => animationCounter($('[data-number1]', svg), numbers.n1)
                    })
                    .to($('.fig1-mask', svg), {
                        duration: 2,
                        attr: {
                            x: 401,
                            width: 0
                        }
                    }, '<')
                    .to(this, {
                        onStart: () => animationCounter($('[data-number2]', svg), numbers.n2)
                    }, '<+=1');

            $('[data-number1], [data-number2]', svg).text('0');
            ScrollTrigger.create({
                trigger: this,
                // markers: true,
                animation: tl,
                onEnter: () => tl?.restart(),
                onEnterBack: () => tl?.restart(),
            })
        });

        $('svg#fig2').each(function () {
            let svg = $(this),
                numbers = {
                    n1: $('[data-number1]', svg).text(),
                },
                animationCounter = (elem, end) => {
                    $({ someValue: 0 }).animate({ someValue: end }, {
                        duration: 1000,
                        easing: 'swing',
                        step: function () {
                            elem.text(Math.ceil(this.someValue).toString().numberWithspace());
                        },
                        complete: function () {
                            elem.text(end.toString().numberWithspace());
                        }
                    });
                },
                tl = gsap.timeline()
                    .set($('[data-number1]', svg), {
                        innerHTML: 0
                    })
                    .to(this, {
                        onStart: () => animationCounter($('[data-number1]', svg), numbers.n1)
                    });

            $('[data-number1]', svg).text('0');
            ScrollTrigger.create({
                trigger: this,
                // markers: true,
                animation: tl,
                onEnter: () => tl?.restart(),
                onEnterBack: () => tl?.restart(),
            })
        });

        if ($('canvas.chartjs').length)
            new SiteChart();

        $('.carrousel').each(function () {
            const slider = $(this).slick({
                centerMode: true,
                infinite: true,
                slidesToShow: 3,
                variableWidth: true,
                prevArrow: '.buttons .align button.prev',
                nextArrow: '.buttons .align button.next',
            });

            // Add custom class to next or previous slide depending on change direction
            slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                let nextIndex = currentSlide + 1; // assume moving right

                if (currentSlide - 1 == nextSlide || (nextSlide + 1 == slick.slideCount && currentSlide < nextSlide))
                    nextIndex = currentSlide - 1; // nope, moving left

                $(`[data-slick-index="${nextIndex}"]`).addClass('slick-target');
            });

            // clear custom class after transition
            slider.on('afterChange', () => {
                $('.slick-slide').removeClass('slick-target');
            });
        });
        /* /DATA PAGES */



        /* MATCHING */
        $('.matching-modal .close').click(function () {
            $('html').removeClass('modal-open');
            $('.matching-modal').removeClass('active');
        });

        $('#matche-profil').click(function () {
            $('html').addClass('modal-open');
            $('.matching-modal, .matching-modal .modal-cv').addClass('active');
            $('.matching-modal .modal-loading, .matching-modal .modal-loading .matching').removeClass('active');
            $('.matching-modal input[type="file"]').val('');
            $('.matching-modal input:checked').prop('checked', false);
        });

        $('#form-matching-metier').submit(function () {
            const file = $('.matching-modal .modal-cv input[name="cv"]');
            if (file[0].files[0].size > file.data('maxsize') * 1000) {
                alert('Le fichier dépasse la taille maximale autorisée.');
                $('.matching-modal .close').click();
                return false;
            }

            $('.matching-modal .modal-cv').removeClass('active');
            $('.matching-modal .modal-loading').addClass('active');
            const elem = $('.matching-modal .modal-loading .analyse .analyse-trouve');
            elem.hide();
            $('.skills-plural, .professions-plural', elem).hide();

            const formData = new FormData(this);
            formData.append('ajax', 1);

            $.ajax({
                type: "POST",
                url: this.action,
                success: function (data) {
                    if (data.success) {
                        $('.matching-modal .modal-loading .analyse').addClass('active');
                        elem.show();

                        $('.skills', elem).text(data.data.skills);
                        $('.professions', elem).text(data.data.professions);

                        if (data.data.skills > 1)
                            $('.skills-plural', elem).show();
                        if (data.data.professions > 1)
                            $('.professions-plural', elem).show();
                        setTimeout(() => {
                            $('.matching-modal .modal-loading .matching').addClass('active');
                        }, 1500);

                        setTimeout(() => {
                            location = '/matching/metier/resultats';
                        }, 2500);
                    } else {
                        alert(data.msg);
                        $('.matching-modal .close').click();
                    }
                },
                data: formData,
                cache: false,
                processData: false,
                contentType: false
            });

            return false;
        });

        $('#form-matching-emploi').submit(function () {
            const file = $('.matching-modal .modal-cv input[name="cv"]');
            if (file[0].files[0].size > file.data('maxsize') * 1000) {
                alert('Le fichier dépasse la taille maximale autorisée.');
                $('.matching-modal .close').click();
                return false;
            }

            $('.matching-modal .modal-cv').removeClass('active');
            $('.matching-modal .modal-loading').addClass('active');
            const elem = $('.matching-modal .modal-loading .analyse .analyse-trouve');
            elem.hide();
            $('.skills-plural, .professions-plural', elem).hide();

            const formData = new FormData(this);
            formData.append('ajax', 1);

            $.ajax({
                type: "POST",
                url: this.action,
                success: function (data) {
                    if (data.success) {
                        $('.matching-modal .modal-loading .analyse').addClass('active');
                        elem.show();

                        $('.skills', elem).text(data.data.skills);
                        $('.professions', elem).text(data.data.professions);

                        if (data.data.skills > 1)
                            $('.skills-plural', elem).show();
                        if (data.data.professions > 1)
                            $('.professions-plural', elem).show();

                        setTimeout(() => {
                            $('.matching-modal .modal-loading .matching').addClass('active');
                        }, 1500);

                        setTimeout(() => {
                            location = '/matching/emploi/resultats';
                        }, 2500);
                    } else {
                        alert(data.msg);
                        $('.matching-modal .close').click();
                    }
                },
                data: formData,
                cache: false,
                processData: false,
                contentType: false
            });

            return false;
        });

        $('.range .slider input[type="range"]').change(function () {
            const elem = $(this),
                text = $(`datalist#${elem.attr('list')} option[value="${elem.val()}"]`).text();
            $('.range .lieu').text(text);
        });

        $('.radio[type="checkbox"]').change(function () {
            const name = $(this).attr('name');
            $(`.radio[type="checkbox"][name="${name}"]`).not(this).prop('checked', false);
        });

        $('.autocomplete').each(function () {
            let $this = $(this);
            const select = $this.select2({
                ajax: {
                    delay: 250,
                    language: "fr",
                    url: '/matching/autocomplete',
                    data: function (params) {
                        return {
                            f: $this.data('type'),
                            q: params.term
                        };
                    },
                }
            }).change(function () {
                if ($this.val().length)
                    $this.addClass('selected');
                else
                    $this.removeClass('selected');
            });
            $('+ .select2 .select2-search__field', select).attr('placeholder', $this.data('placeholder'));
        });

        $('.customselect').each(function () {
            let $this = $(this);
            const select = $this.select2()
                .change(function () {
                    if ($this.val().length)
                        $this.addClass('selected');
                    else
                        $this.removeClass('selected');
                });
            $('+ .select2 .select2-search__field', select).attr('placeholder', $this.data('placeholder'));
        });

        $('input.text-add').each(function () {
            let $field = $(this),
                data = [];
            $('+ ul li', $field).each(function () {
                data.push($field.text().trim().removeAccents().toLowerCase());
            });
            data = Array.from(new Set(data));
            $field.keypress(function (event) {
                if (event.which == 13) {
                    event.preventDefault();
                    const id = $field.attr('id'),
                        text = $field.val().trim();

                    if (data.indexOf(text.removeAccents().toLowerCase()) >= 0) {
                        $('+ ul li', $field).each(function () {
                            if ($('label', this).text().removeAccents().toLowerCase() == text.removeAccents().toLowerCase())
                                $('input', this).prop('checked', true);
                        });
                        $field.val('');
                        return;
                    }
                    data.push(text.removeAccents().toLowerCase());

                    const uuid = uuidv4();
                    const html = $(`<li class="c-gray"><span class="custom-checkbox"><input type="checkbox" id="${uuid}" name="filtre[${id}][]" checked><label for="${uuid}"></label></span><label for="${uuid}">${text}</label></li>`);
                    html.find('input').val(text);
                    $('+ ul', $field).append(html);
                    $field.val('');
                    html.find('input').change(function () {
                        $('form.emploi-form').submit();
                    }).trigger('change');
                }
            });
        });

        $('#results-content nav.footer a').each(function () {
            this.href += '#results-content';
        });

        let currentXhr;
        $('form.emploi-form').submit(function (e) {
            e.preventDefault();
            const data = new FormData(document.querySelector('form.emploi-form'));
            currentXhr && currentXhr.readyState != 4 && currentXhr.abort(); // clear previous request

            if (typeof gtag == 'function' && $('form.emploi-form .recherche input').val()) {
                gtag('event', 'job_search', {
                    search_term: $('form.emploi-form .recherche input').val()
                });
            }

            $('#results-content').parent().find('.loading').addClass('show');
            let search = location.search.replace(/^\?/i, '').split('&').filter(x => !/^p=/i.test(x));
            currentXhr = $.ajax({
                type: 'POST',
                url: location.pathname + (search ? '?' + search.join('&') : ''),
                success: function (data) {
                    if (data.success) {
                        $('#results-content').html(data.data);
                        $('#results-content nav.footer a').each(function () {
                            this.href += '#results-content';
                        });
                        $('#results-content').parent().find('.loading.show').removeClass('show');
                    } else {
                        if (data.msg == 'reload')
                            location.href = '/trouver-votre-futur-emploi/consultez-les-offres-de-la-filiere-et-matchez-les-avec-votre-profil/';
                        else
                            alert(data.msg);
                    }
                },
                data: data,
                cache: false,
                processData: false,
                contentType: false
            });

            return false;
        });

        $('form.emploi-form .recherche input').on('keyup', function (e) {
            if (!$(this).val() && (e.originalEvent.key == "Backspace" || e.originalEvent.key == "Delete"))
                $('form.emploi-form').submit();
        });

        $('#open-filters').change(function () {
            if ($(this).is(':checked'))
                $('html').addClass('filter-open');
            else
                $('html').removeClass('filter-open');
        });

        $(window).resize(function () {
            if ($('html').hasClass('filter-open') && window.matchMedia("(min-width: 1024px)").matches)
                $('html').removeClass('filter-open');
            else if ($('#open-filters').is(':checked') && !window.matchMedia("(min-width: 1024px)").matches)
                $('html').addClass('filter-open');
        });
        function count_filter() {
            let count = $('input[type="checkbox"]:checked, input[type="radio"]:checked, select:selected', 'form.emploi-form .mobile-popin').not('.hidden, #date-4').length;
            $('select', 'form.emploi-form .mobile-popin').each(function () {
                if ($(this).val().length)
                    count++;
            });
            $('form.emploi-form .filters .count').text(count);
            if (count) {
                $('form.emploi-form .filters .count').show();
                $('form.emploi-form .filters .icon-equalizer').hide();
            } else {
                $('form.emploi-form .filters .count').hide();
                $('form.emploi-form .filters .icon-equalizer').show();
            }
        }
        $('select, input', 'form.emploi-form').not('.hidden').change(function () {
            count_filter();
            $('form.emploi-form').submit();
        });
        count_filter();
        /* /MATCHING */



        /* RESSOURCES */
        function ressource_animate() {
            $('form.ressource-form #results-content article').each(function () {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: this,
                        // markers: true,
                        start: "center 100%",
                    }
                });
                tl.fromTo(this,
                    {
                        opacity: 0
                    },
                    {
                        opacity: 1
                    }
                );
            });
        };
        ressource_animate();

        const masonryOptions = {
            itemSelector: 'article',
            transitionDuration: 0,
            gutter: 20
        };
        let list = $('form.ressource-form .list');
        list.masonry(masonryOptions);
        list.imagesLoaded().progress(function () {
            list.masonry('layout');
        });

        $('form.ressource-form').submit(function (e) {
            e.preventDefault();
            const data = new FormData(document.querySelector('form.ressource-form'));
            currentXhr && currentXhr.readyState != 4 && currentXhr.abort(); // clear previous request

            $('#results-content').parent().find('.loading').addClass('show');
            let search = location.search.replace(/^\?/i, '').split('&').filter(x => !/^p=/i.test(x));
            currentXhr = $.ajax({
                type: 'POST',
                url: location.pathname + (search ? '?' + search.join('&') : ''),
                success: function (data) {
                    if (data.success) {
                        ScrollTrigger.killAll();
                        $('#results-content').html(data.data);
                        $('#results-content nav.footer a').each(function () {
                            this.href += '#results-content';
                        });
                        $('#results-content').parent().find('.loading.show').removeClass('show');
                        ressource_animate();
                        ScrollTrigger.refresh(true);
                        list = $('form.ressource-form .list');
                        list.masonry(masonryOptions);
                        list.imagesLoaded().progress(function () {
                            list.masonry('layout');
                        });
                        $('input[name="filtre[q]"]', 'form.ressource-form').change(function () {
                            $('form.ressource-form').submit();
                        });
                    } else {
                        if (data.msg == 'reload')
                            location.href = '/ressources/';
                        else
                            alert(data.msg);
                    }
                },
                data: data,
                cache: false,
                processData: false,
                contentType: false
            });

            return false;
        });

        $('select, input', 'form.ressource-form').not('.hidden').change(function () {
            $('form.ressource-form').submit();
        });
        /* /RESSOURCES */

        $('body.salarie-demandeur-emploi').removeClass('no-animation');
    }
    onResize() {
        this.resizeContent();
        if ($('body').hasClass('home'))
            this.homeLinkPosition();
        if ($('body').hasClass('explorer'))
            this.explorerLinkPosition();
    }
    resizeContent() {
        const elem = $('.resizeContent'),
            ratio = 1,
            windowWidth = window.innerWidth,
            windowHeight = window.innerHeight;

        let css = {
            width: '100vw',
            height: $('body').hasClass('home-explorer') ? '' : '100vh',
            top: 0,
            left: 0
        };

        if (SiteApp.getOrientation() == 'landscape') {
            css = {
                width: '100vw',
                height: windowWidth / ratio,
                top: ((windowWidth / ratio) - windowHeight) / -2,
                left: 0
            }
        } else if ($('body').hasClass('bg-image-zoom')) {
            css = {
                width: windowHeight * ratio,
                height: '100vh',
                top: 0,
                left: ((windowHeight * ratio) - windowWidth) / -2
            }
        }

        elem.css(css);
    }
    homeLinkPosition() {
        const sourceSize = {
            width: 1367,
            height: 1367
        },
            currentSize = {
                width: $('#home #content .lexique').width(),
                height: $('#home #content .lexique').height()
            },
            ratio = currentSize.width / sourceSize.width,
            positions = [
                {
                    elem: '#home .lexique li.production-dhydrogene',
                    button: {
                        top: 600,
                        left: 510,
                    }
                },
                {
                    elem: '#home .lexique li.production-de-biogaz',
                    button: {
                        top: 648,
                        left: 542,
                    }
                },
                {
                    elem: '#home .lexique li.stockage-souterrain-de-gaz',
                    button: {
                        top: 633,
                        left: 365,
                    }
                },
                {
                    elem: '#home .lexique li.reseau-de-transport-de-gaz',
                    button: {
                        top: 666,
                        left: 444,
                    }
                },
                {
                    elem: '#home .lexique li.thalassothermie',
                    button: {
                        top: 726,
                        left: 372,
                    }
                },
                {
                    elem: '#home .lexique li.reseau-de-distribution-de-gaz',
                    button: {
                        top: 717,
                        left: 460,
                    }
                },
                {
                    elem: '#home .lexique li.terminal-hydrogene',
                    button: {
                        top: 757,
                        left: 490,
                    }
                },
                {
                    elem: '#home .lexique li.terminal-gnl',
                    button: {
                        top: 736,
                        left: 540,
                    }
                },
                {
                    elem: '#home .lexique li.valorisation-energetique-des-dechets',
                    button: {
                        top: 730,
                        left: 762,
                    }
                },
                {
                    elem: '#home .lexique li.stockage-emplissage-gpl',
                    button: {
                        top: 776,
                        left: 718,
                    }
                },
                {
                    elem: '#home .lexique li.reseau-de-chaleur',
                    button: {
                        top: 726,
                        left: 956,
                    }
                },
                {
                    elem: '#home .lexique li.chaleur-renouvelable',
                    button: {
                        top: 790,
                        left: 936,
                    }
                },
                {
                    elem: '#home .lexique li.decarbonation-de-lindustrie',
                    button: {
                        top: 834,
                        left: 990,
                    }
                },
                {
                    elem: '#home .lexique li.avitaillement-en-gaz',
                    button: {
                        top: 792,
                        left: 1064,
                    }
                },
                {
                    elem: '#home .lexique li.installation-maintenance-equipements',
                    button: {
                        top: 854,
                        left: 1192,
                    }
                },
                {
                    elem: '#home .lexique li.efficacite-energetique',
                    button: {
                        top: 725,
                        left: 1132,
                    }
                },
                {
                    elem: '#home .lexique li.chaleur-de-recuperation',
                    button: {
                        top: 646,
                        left: 1158,
                    }
                },
                {
                    elem: '#home .lexique li.installation-maintenance-de-pac-air-eau',
                    button: {
                        top: 855,
                        left: 1253,
                    }
                },
                {
                    elem: '#home .lexique li.installation-maintenance-equipements-2',
                    button: {
                        top: 910,
                        left: 1256,
                    }
                },
                {
                    elem: '#home .lexique li.reseau-de-froid',
                    button: {
                        top: 736,
                        left: 1062,
                    }
                },
                {
                    elem: '#home .lexique li.geothermie',
                    button: {
                        top: 810,
                        left: 900,
                    }
                },
                {
                    elem: '#home .lexique li.solaire-thermique',
                    button: {
                        top: 810,
                        left: 1196,
                    }
                },
                {
                    elem: '#home .lexique li.solaire-thermique-2',
                    button: {
                        top: 556,
                        left: 505,
                    }
                },
                {
                    elem: '#home .lexique li.e-methane-e-fuel-gazeification',
                    button: {
                        top: 642,
                        left: 1054,
                    }
                },
                {
                    elem: '#home .lexique li.biomasse',
                    button: {
                        top: 530,
                        left: 1186,
                    }
                },
                {
                    elem: '#home .lexique li.vue-ensemble-de-nos-univers-metiers',
                    button: {
                        top: 578,
                        left: 730,
                    }
                },
            ];

        positions.forEach(pos => {
            const block = $(pos.elem);
            block.css({
                transform: `scale(${ratio})`,
                top: (pos.button.top + block.height() / 2) * ratio - block.height() / 2,
                left: (pos.button.left + block.width() / 2) * ratio - block.width() / 2,
            });
        });

        $('#home #content .lexique ul.load').removeClass('load');
    }
    explorerLinkPosition() {
        const sourceSize = {
            width: 1367,
            height: 1367
        },
            currentSize = {
                width: window.innerWidth,
                height: window.innerHeight
            },
            ratio = currentSize.width / sourceSize.width,
            positions = [
                {
                    name: 'production-energie',
                    button: {
                        top: 665,
                        left: 224,
                    }
                },
                {
                    name: 'transport-stockage',
                    button: {
                        top: 586,
                        left: 377,
                    }
                },
                {
                    name: 'distribution',
                    button: {
                        top: 557,
                        left: 608,
                    }
                },
                {
                    name: 'commercialisation-vente',
                    button: {
                        top: 601,
                        left: 733,
                    }
                },
                {
                    name: 'services-energetiques-equipements-et-installations',
                    button: {
                        top: 591,
                        left: 916,
                    }
                }
            ];

        const svg = $('svg path, svg polyline', '#home .overlay');

        if ($('body').hasClass('home-explorer') && SiteApp.getOrientation() == 'portrait') {
            $('#home > #content .univers').css('padding', `${$('#header').height() / 10}rem 0`);
            $('#home .univers li').removeAttr('style');
            return;
        }

        positions.forEach(pos => {
            const block = $(`#home .univers li.${pos.name}`);
            block.css({
                transform: `scale(${ratio})`,
                top: (pos.button.top + block.height() / 2) * ratio - block.height() / 2,
                left: (pos.button.left + block.width() / 2) * ratio - block.width() / 2,
            });
            block.on('mouseenter focusin', function () {
                svg.removeClass('hover');
                $(`#overlay-${pos.name}`, '#home .overlay').addClass('hover');
            });
            block.on('mouseleave focusout', function () {
                svg.removeClass('hover');
            });
        });

        svg.on('mouseenter', function () {
            const id = this.id.replace(/^overlay-/i, '');
            document.querySelectorAll(`#home .univers li a`).forEach(x => x.classList.remove('active'));
            document.querySelector(`#home .univers li.${id} a`).classList.add('active');
        });
        svg.on('mouseleave', function () {
            document.querySelectorAll(`#home .univers li a`).forEach(x => x.classList.remove('active'));
        });
        svg.on('click', function () {
            const id = this.id.replace(/^overlay-/i, '');
            document.querySelector(`#home .univers li.${id} a`).click();
        });
    }
    static isIE() {
        return /MSIE|Trident/i.test(navigator.userAgent);
    }
    static isMobile() {
        return $('body').hasClass('mobile');
    }
    static getOrientation() {
        if (window.matchMedia("(orientation: portrait)").matches)
            return 'portrait';

        if (window.matchMedia("(orientation: landscape)").matches)
            return 'landscape';

        return false;
    }
    static isTouchDevice() {
        return ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
    }
}